module.exports = __webpack_public_path__ + "img/18_31.48874b1a.png";